import axios from "axios";
import { ElMessageBox, ElMessage } from "element-plus";
import { getToken } from "@/utils/auth";
import { ErrorCode, StatusCode } from "@/constants/code.constant";
import { useUserStore } from "@/store";
import { ErrorMsg } from "@/constants/message.constant";

//  instance
const service = axios.create({
  baseURL:
    process.env.VUE_APP_API_BASE_URL ??
    window.location.href.split("/").slice(0, 3).join("/") + "/api/",
  timeout: 60000, // request timeout
});

//  request　interceptor
service.interceptors.request.use(
  (config) => {
    console.log(config.url);
    const userStore = useUserStore();
    if (userStore.getToken) {
      config.headers["Authorization"] = "bearer " + getToken();
    }
    return config;
  },
  (error) => {
    console.log(error); //  debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    //エラー
    if (res.code !== ErrorCode.Success) {
      // code:5xxxx は各種フォームのチェックエラーメッセージので、
      // エラーダイアログ表示ではなく、画面のinputの下側でエラーメッセージ表示
      if (res.code < 50000 || res.code >= 60000) {
        ElMessageBox.alert(res.message || "Error", {
          type: "error",
        });
      }
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return response;
    }
  },
  (error) => {
    console.log(error); //  debug
    const statusCode = error.response.status;
    let errMsg: string;
    //TOKEN切れ
    if (statusCode === StatusCode.Unauthorized) {
      errMsg = ErrorMsg.InvalidToken;
      const userStore = useUserStore();
      //  再度ログインさせる
      userStore.resetToken().then(() => {
        //1秒後ログイン画面に遷移

        setTimeout(() => {
          if (location.pathname !== "/login") {
            location.reload();
          }
        }, 1000);
      });
    }
    //権限なし
    else if (statusCode === StatusCode.Forbidden) {
      errMsg = ErrorMsg.Forbidden;
    } else {
      errMsg = error.message;
    }
    ElMessage({
      message: errMsg,
      type: "error",
      duration: 4 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;
